import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingComponent} from "./landing/landing.component";
import {ShellComponent} from "./shell/shell.component";

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: LandingComponent
    },
    {
        path: 'home',
        component: ShellComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('../pages/pages.module').then((m) => m.PagesModule),
            },
        ]
    }
];

/**
 * Defines the routing configuration for the CoreModule.The first route specifies that when the application is accessed at the root URL,
 * the LandingComponent should be displayed.The second route specifies that when the application is accessed at the '/home' URL,
 * the ShellComponent should be displayed.The ShellComponent acts as a container for other components, and the children property specifies that the child routes are loaded from the FeaturesModule.
 */
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CoreRoutingModule {
}
